// src/components/approval-line/ApprovalLineConfirmDialog.jsx
// ✅ 상신(저장) 직전 결재선 재확인 다이얼로그 — 4개 문서 작성 페이지(지출/수입
// 기안·지출/수입 결의) 공통. 취소 시 작성 화면 유지(저장 진행 안 함), 상신 클릭
// 시에만 실제 저장이 진행된다(호출부에서 onConfirm에 저장 로직을 연결).
import React from "react";
import styles from "./ApprovalLineConfirmDialog.module.css";

const STATUS_CLASS = {
  기안: styles.statusDraft,
  결재: styles.statusApprove,
  합의: styles.statusAgree,
};

export default function ApprovalLineConfirmDialog({ approvers = [], onCancel, onConfirm }) {
  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.title}>결재라인을 확인해 주세요</h3>

        <div className={styles.list}>
          {approvers.map((a, i) => (
            <div className={styles.row} key={a.id ?? i}>
              <span className={styles.order}>{i + 1}.</span>
              <span className={`${styles.statusTag} ${STATUS_CLASS[a.status] || ""}`}>
                {a.status || "-"}
              </span>
              <span className={styles.name}>{a.name}</span>
              <span className={styles.position}>{a.position}</span>
            </div>
          ))}
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>
            취소
          </button>
          <button type="button" className={styles.submitBtn} onClick={onConfirm}>
            상신
          </button>
        </div>
      </div>
    </div>
  );
}
